'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = typeToReducer;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function typeToReducer(reducerMap, initialState) {
  var makeType = function makeType(prefix, type) {
    return prefix.concat(type).join('_');
  };

  var iterator = function iterator(reducers) {
    var initial = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var prefix = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

    var reducerTypes = Object.keys(reducers || {});
    return reducerTypes.reduce(function (acc, type) {
      var reducer = reducers[type];
      return typeof reducer === 'function' ? _extends({}, acc, _defineProperty({}, makeType(prefix, type), reducer)) : iterator(reducer, acc, [makeType(prefix, type)]);
    }, initial);
  };

  var flattened = iterator(reducerMap);

  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
    var action = arguments[1];

    var reducer = flattened[action.type];
    return reducer ? reducer(state, action) : state;
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/type-to-reducer/lib/index.js
 ** module id = 470
 ** module chunks = 73
 **/